import { Suspense, memo } from 'react'

import { Outlet } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

export const BankLicenseWrapper = memo(() => (
  <Suspense fallback={<CircularProgress centered />}>
    <Outlet />
  </Suspense>
))
